export default "__VITE_ASSET__Dj_8mw4z__"